import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import Buildings from '@/roc/building';
import BuildingInstance from '@/roc/grid/BuildingInstance';
import Id from "@/roc/grid/Id";
export const useLayoutStore = defineStore('Layout', () => {
    const buildings = ref({});
    const idToBuildingTemplateMap = {};
    const readyBuildings = Array();
    for (let i = 0; i < Buildings.length; i++) {
        idToBuildingTemplateMap[Buildings[i].id] = {
            ...Buildings[i]
        };
    }
    const countsById = computed(() => {
        const result = {};
        for (const i in buildings.value) {
            if (result[buildings.value[i].templateId] === undefined) {
                result[buildings.value[i].templateId] = 0;
            }
            result[buildings.value[i].templateId]++;
        }
        return result;
    });
    const calculateBuildingHappiness = function () {
        for (const i in buildings.value) {
            setTimeout((index) => {
                if (buildings.value[index]) {
                    buildings.value[index].calculateHappiness();
                }
            }, 1, i);
        }
    };
    const applyBuildingModifiers = (building = null) => {
        if (building === null) {
            for (const i in buildings.value) {
                setTimeout((index) => {
                    if (buildings.value[index]) {
                        buildings.value[index].applyProductionModifiers();
                    }
                }, 10, i);
            }
        }
        else {
            setTimeout(() => {
                if (building) {
                    building.applyProductionModifiers();
                }
            }, 10);
        }
    };
    return {
        buildings,
        mapBuildings(callback) {
            for (const i in buildings.value) {
                if (callback(buildings.value[i], i) === false) {
                    return;
                }
            }
        },
        getBuildingTemplateByType(type) {
            for (let i = 0; i < Buildings.length; i++) {
                if (Buildings[i].type === type) {
                    return {
                        ...Buildings[i],
                    };
                }
            }
            return null;
        },
        getBuildingTemplateById(id) {
            if (idToBuildingTemplateMap[id] !== undefined) {
                return {
                    ...idToBuildingTemplateMap[id]
                };
            }
            return null;
        },
        getBuildingById(id) {
            return buildings.value[id];
        },
        isLayoutEmpty() {
            return Object.keys(buildings.value).length === 0;
        },
        getCountById(templateId) {
            return countsById.value[templateId] || 0;
        },
        buildingIds: computed(() => {
            return Object.keys(buildings.value);
        }),
        // mutations
        loadLayout(layout) {
            buildings.value = {};
            for (let i = 0; i < layout.length; i++) {
                const id = Id.generate();
                buildings.value[id] = new BuildingInstance({
                    ...idToBuildingTemplateMap[layout[i].id]
                }, layout[i].tileX, layout[i].tileY, layout[i].rotate, layout[i].level, layout[i].era, id);
            }
        },
        placeBuilding(template, props) {
            const id = Id.generate();
            buildings.value[id] = new BuildingInstance({
                ...template
            }, props.x, props.y, props.rotate, props.level, props.era, id);
            applyBuildingModifiers(buildings.value[id]);
            applyBuildingModifiers();
        },
        addBuilding(building) {
            buildings.value[building.id] = building;
            applyBuildingModifiers(building);
            applyBuildingModifiers();
        },
        removeBuilding(id) {
            delete buildings.value[id];
            applyBuildingModifiers();
        },
        changeBuildingLevel(id, level) {
            const _old = buildings.value[id];
            buildings.value[id] = new BuildingInstance({
                ..._old.template
            }, _old.x, _old.y, _old.isRotated, level, _old.era, id);
            calculateBuildingHappiness();
            applyBuildingModifiers(buildings.value[id]);
            applyBuildingModifiers();
        },
        changeBuildingEra(id, era) {
            const _old = buildings.value[id];
            buildings.value[id] = new BuildingInstance({
                ..._old.template
            }, _old.x, _old.y, _old.isRotated, _old.level, era, id);
            calculateBuildingHappiness();
            applyBuildingModifiers(buildings.value[id]);
            applyBuildingModifiers();
        },
        setBuildingReady(id) {
            readyBuildings.push(id);
            if (readyBuildings.length === Object.keys(buildings).length) {
                calculateBuildingHappiness();
                applyBuildingModifiers();
                return true;
            }
            return false;
        },
        updateHappiness() {
            calculateBuildingHappiness();
        },
        applyBuildingModifiers,
    };
});
